module.exports = __webpack_public_path__ + "img/marker-bg-36.f1cf3629.svg";